import { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
//Srcs
import "../../Style/actionstyle.scss";
import Delete from "../Include/Delete"
import { DELETE_INVENTORY_PLAN } from "../../Schema/InventoryPlan";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import InventoryPlanForm from "./InventoryPlanForm";
import PrintPlan from "./PrintPlan";

export default function InventoryPlanAction({ editData, setRefetch }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  //====================  ==================
  const [deleteInventoryPlan] = useMutation(DELETE_INVENTORY_PLAN, {
    onCompleted: ({ deleteInventoryPlan }) => {
      setLoading(false);
      if (deleteInventoryPlan?.status === true) {
        setAlert(true, "success", deleteInventoryPlan?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteInventoryPlan?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteInventoryPlan({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
            onClick={handleOpenEdit}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {
        openEdit && <InventoryPlanForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle={"Update"}
        />
      }

      {/* {
        openDel && <Delete
          open={openDel}
          handleClose={handleCloseDel}
          title={"ផែនការ"}
          loading={loading}
          handleDelete={handleDelete}
        />
      } */}

      {
        openDel && <PrintPlan
          open={openDel}
          handleClose={handleCloseDel}
          editData={editData}
        />
      }

    </div>
  );
}
